<template>
  <h1 class="sr-only">본문 내용</h1>
  <div class="l-content-inner">
    <div class="l-content">
      <div class="dashboard-wrap">
        <SearchKeyword
          v-model:keyword="keyword"
          @keyword-changed="onSearchKeywordChange"
        />
        <div class="favorite-wrap">
          <h2 class="title">자주쓰는 메뉴설정</h2>
          <ul class="favorite-list">
            <li
              class="favorite-item"
              v-for="(item, idx) in data.menu.list"
              :key="idx"
            >
              <!-- D: 즐겨찾기 is-favorite 추가 -->
              <a
                href="javascript:void(0);"
                :class="item.useYn == 'Y' ? 'is-favorite' : ''"
                @click="routerCmd('routerMenu', { menuUrl: item.menuUrl })"
              >
                <span class="text">{{ item.menuSeNm }}</span>
              </a>
            </li>
            <li class="favorite-item has-setting">
              <a href="javascript:void(0);" @click="btnCmdFun('setting')">
                <span class="sr-only">설정</span>
              </a>
            </li>
          </ul>
        </div>
        <!-- D: PC에서 나오는 영역 주문, 매입,출고 현황 -->
        <div class="order-status only-pc">
          <div class="order-status-first">
            <div class="hgroup">
              <h2 class="c-title-level2">주문현황</h2>
              <p class="date">
                {{ data.order.search.searchDateSt }} ~
                {{ data.order.search.searchDateEd }}
              </p>
            </div>
            <div class="order-step">
              <ol>
                <li class="order-step-item">
                  <a
                    href="javascript:void(0);"
                    class="anchor type-waiting"
                    @click="
                      routerCmd('order', { info: data.order.orderCnt01.cdVl })
                    "
                  >
                    <strong class="subject">{{
                      data.order.orderCnt01.cdNm
                    }}</strong>
                    <span class="system">{{
                      data.order.orderCnt01.statCnt
                    }}</span>
                  </a>
                </li>
                <li class="order-step-item">
                  <a
                    href="javascript:void(0);"
                    class="anchor type-received"
                    @click="
                      routerCmd('order', { info: data.order.orderCnt02.cdVl })
                    "
                  >
                    <strong class="subject">{{
                      data.order.orderCnt02.cdNm
                    }}</strong>
                    <span class="system">{{
                      data.order.orderCnt02.statCnt
                    }}</span>
                  </a>
                </li>
                <li class="order-step-item">
                  <a
                    href="javascript:void(0);"
                    class="anchor type-preparing"
                    @click="
                      routerCmd('order', { info: data.order.orderCnt03.cdVl })
                    "
                  >
                    <strong class="subject">{{
                      data.order.orderCnt03.cdNm
                    }}</strong>
                    <span class="system">{{
                      data.order.orderCnt03.statCnt
                    }}</span>
                  </a>
                </li>
                <li class="order-step-item">
                  <a
                    href="javascript:void(0);"
                    class="anchor type-shipping"
                    @click="
                      routerCmd('order', { info: data.order.orderCnt04.cdVl })
                    "
                  >
                    <strong class="subject">{{
                      data.order.orderCnt04.cdNm
                    }}</strong>
                    <span class="system">{{
                      data.order.orderCnt04.statCnt
                    }}</span>
                  </a>
                </li>
                <li class="order-step-item">
                  <a
                    href="javascript:void(0);"
                    class="anchor type-completed"
                    @click="
                      routerCmd('order', { info: data.order.orderCnt05.cdVl })
                    "
                  >
                    <strong class="subject">{{
                      data.order.orderCnt05.cdNm
                    }}</strong>
                    <span class="system">{{
                      data.order.orderCnt05.statCnt
                    }}</span>
                  </a>
                </li>
              </ol>
            </div>
            <a
              href="javascript:void(0);"
              class="c-readmore type-round"
              @click="routerCmd('order', { info: '' })"
            >
              <i class="c-icon icon-plus-black size-xsmall"></i>
              <span class="text">전체보기</span>
            </a>
          </div>
          <div class="order-status-item">
            <!-- D: chart -->
            <MainChart01 :data="data.chart01"></MainChart01>
            <!-- D: // chart -->
          </div>
          <div class="order-status-item">
            <!-- D: chart -->
            <MainChart02 :data="data.chart02"></MainChart02>
            <!-- D: // chart -->
          </div>
        </div>
        <!-- // D: PC에서 나오는 영역 주문, 매입,출고 현황 -->
      </div>

      <!-- 제품 -->
      <div class="column-products">
        <div class="col col-1">
          <!-- D: tabs -->
          <div class="c-text-tabs">
            <ul>
              <li class="tab-item">
                <a
                  href="javascript:void(0);"
                  role="tab"
                  id="isTab-1-1"
                  :class="data.isTab1 ? 'tab-anchor is-active' : 'tab-anchor'"
                  :aria-selected="data.isTab1 ? true : false"
                  @click.stop="tabActive"
                  >{{
                    data.orderCnt > 0 ? "자주 구매한 제품" : "많이 찾는 제품"
                  }}</a
                >
              </li>
              <li class="tab-item">
                <a
                  href="javascript:void(0);"
                  role="tab"
                  id="isTab-1-2"
                  :class="data.isTab1 ? 'tab-anchor' : 'tab-anchor is-active'"
                  :aria-selected="data.isTab1 ? false : true"
                  @click.stop="tabActive"
                  >{{
                    data.orderCnt > 0 ? "최근 구매한 제품" : "많이 구매한 제품"
                  }}</a
                >
              </li>
            </ul>
          </div>

          <!-- D: tab content -->
          <div class="tab-panel-wrap">
            <div class="tab-panel" role="tabpanel" aria-labelledby="tab1-1">
              <!-- 스와이퍼 Vue 컴포넌트 영역 + indicator -->
              <MainSwiper01
                :data="data.swiper"
                :type="data.swiper.orderType"
                :zempNo="data.swiper.kunn2"
                @chage-tab-type="(type) => changeTabType(type)"
              />
              <!-- 스와이퍼 Vue 컴포넌트 영역 + indicator -->
            </div>
            <div
              class="tab-panel"
              role="tabpanel"
              aria-labelledby="tab1-2"
              hidden
            >
              <!-- D: 스와이퍼 + 상품 데이터를 불러주세요 -->
            </div>
          </div>
        </div>

        <div class="col col-2">
          <div class="c-text-tabs">
            <ul>
              <li class="tab-item">
                <a
                  href="javascript:void(0);"
                  role="tab"
                  id="isTab-2-1"
                  :class="data.isTab2 ? 'tab-anchor is-active' : 'tab-anchor'"
                  :aria-selected="data.isTab2 ? true : false"
                  @click.stop="tabActive"
                  >인기 제품</a
                >
              </li>
              <li class="tab-item">
                <a
                  href="javascript:void(0);"
                  role="tab"
                  id="isTab-2-2"
                  :class="data.isTab2 ? 'tab-anchor' : 'tab-anchor is-active'"
                  :aria-selected="data.isTab2 ? false : true"
                  @click.stop="tabActive"
                  >추천 제품</a
                >
              </li>
            </ul>
          </div>

          <!-- D: tab content -->
          <div class="tab-panel-wrap">
            <div class="tab-panel" role="tabpanel" aria-labelledby="tab2-1">
              <!-- 스와이퍼 Vue 컴포넌트 영역 + indicator -->
              <MainSwiper02
                :data="data.swiper"
                :type="data.swiper.fashionRcmdtnSeCd"
                :zempNo="data.swiper.matkl"
              />
              <!-- 스와이퍼 Vue 컴포넌트 영역 + indicator -->
            </div>
            <div
              class="tab-panel"
              role="tabpanel"
              aria-labelledby="tab2-2"
              hidden
            ></div>
          </div>
        </div>
      </div>

      <!-- 빠른주문 -->
      <div class="single-products" v-if="data.quickSwiper">
        <MainSwiper03
          :data="data.swiper"
          @quick-cnt="() => (data.quickSwiper = false)"
        />
      </div>
    </div>
    <!-- quick -->
    <QuickMenu />
    <!-- //quick -->
  </div>
  <!-- 뉴스&공지사항 -->
  <div class="news-notice-wrap">
    <div class="inner">
      <div class="col">
        <h2 class="c-title-level2">뉴스</h2>
        <!-- Swiper -->
        <MainSwiper04 :data="data.swiper" />
        <!-- Swiper -->
      </div>
      <div class="col">
        <h2 class="c-title-level2">공지사항</h2>
        <div class="notice-list">
          <ul>
            <li
              class="notice-item"
              v-for="(item, idx) in data.notice.list"
              :key="idx"
            >
              <span v-if="item.imptYn == 'Y'" class="c-flag type-red"
                >중요공지</span
              >
              <span
                v-else-if="item.imptYn == 'N' && item.ntcMttrTypeCd == '10'"
                class="c-flag type-green"
                >제품</span
              >
              <span
                v-else-if="item.imptYn == 'N' && item.ntcMttrTypeCd == '20'"
                class="c-flag type-purple"
                >사이트</span
              >
              <span
                v-else-if="item.imptYn == 'N' && item.ntcMttrTypeCd == '30'"
                class="c-flag type-blue"
                >유해화학</span
              >
              <span
                v-else-if="item.imptYn == 'N' && item.ntcMttrTypeCd == '40'"
                class="c-flag type-olive"
                >기타</span
              >
              <a
                href="javascript:void(0);"
                class="subject"
                @click="routerCmd('notice', { ntcMttrSn: item.ntcMttrSn })"
                v-html="sanitizeHTML(item.ntcMttrTitleNm)"
              ></a>
              <span class="date">{{ item.regDt }}</span>
            </li>
          </ul>
        </div>
        <a
          href="javascript:void(0);"
          class="c-readmore"
          @click="routerCmd('noticeAll', {})"
        >
          <i class="c-icon icon-plus-black size-xsmall"></i>
          <span class="text">전체보기</span>
        </a>
      </div>
    </div>
  </div>

  <!-- D: MO에서 나오는 영역 주문, 매입,출고 현황 -->
  <div class="order-status only-mo">
    <div class="order-status-first">
      <div class="hgroup">
        <h2 class="c-title-level2">주문현황</h2>
        <p class="date">
          {{ data.order.search.searchDateSt }} ~
          {{ data.order.search.searchDateEd }}
        </p>
      </div>
      <div class="order-step">
        <ol>
          <li class="order-step-item">
            <a
              class="anchor type-waiting"
              @click="routerCmd('order', { info: data.order.orderCnt01.cdVl })"
            >
              <strong class="subject">{{ data.order.orderCnt01.cdNm }}</strong>
              <span class="system">{{ data.order.orderCnt01.statCnt }}</span>
            </a>
          </li>
          <li class="order-step-item">
            <a
              class="anchor type-received"
              @click="routerCmd('order', { info: data.order.orderCnt02.cdVl })"
            >
              <strong class="subject">{{ data.order.orderCnt02.cdNm }}</strong>
              <span class="system">{{ data.order.orderCnt02.statCnt }}</span>
            </a>
          </li>
          <li class="order-step-item">
            <a
              class="anchor type-preparing"
              @click="routerCmd('order', { info: data.order.orderCnt03.cdVl })"
            >
              <strong class="subject">{{ data.order.orderCnt03.cdNm }}</strong>
              <span class="system">{{ data.order.orderCnt03.statCnt }}</span>
            </a>
          </li>
          <li class="order-step-item">
            <a
              class="anchor type-shipping"
              @click="routerCmd('order', { info: data.order.orderCnt04.cdVl })"
            >
              <strong class="subject">{{ data.order.orderCnt04.cdNm }}</strong>
              <span class="system">{{ data.order.orderCnt04.statCnt }}</span>
            </a>
          </li>
          <li class="order-step-item">
            <a
              class="anchor type-completed"
              @click="routerCmd('order', { info: data.order.orderCnt05.cdVl })"
            >
              <strong class="subject">{{ data.order.orderCnt05.cdNm }}</strong>
              <span class="system">{{ data.order.orderCnt05.statCnt }}</span>
            </a>
          </li>
        </ol>
      </div>
      <a
        class="c-readmore type-round"
        href="javascript:void(0);"
        @click="routerCmd('order', { info: '' })"
      >
        <i class="c-icon icon-plus-black size-xsmall"></i>
        <span class="text">전체보기</span>
      </a>
    </div>
    <div class="order-status-item">
      <MainChart01 :data="data.chart01"></MainChart01>
    </div>
    <div class="order-status-item">
      <MainChart02 :data="data.chart02"></MainChart02>
    </div>
  </div>
  <!-- // D: MO에서 나오는 영역 주문, 매입,출고 현황 -->

  <!-- D: POPUP - Wrap밖으로 호출 필요 -->
  <MenuSettingPop
    v-if="data.popup.isMenuSettingPop"
    :data="data.menu.list"
    @select="selectMenu"
    @close="closePopup"
  />
  <MainOnboardPop
    v-if="data.popup.isMainOnboardPop"
    @close="() => (data.popup.isMainOnboardPop = false)"
  />
</template>

<script setup name="main">
import { onMounted, reactive, inject, ref, provide, watch } from "vue";

import SearchKeyword from "@/components/paintpro/prod/searchKeyword.vue";
import QuickMenu from "@/components/paintpro/quickMenu/quickMenu.vue"; //퀵메뉴
import MenuSettingPop from "@/components/paintpro/main/menuSettingPop.vue"; //자주찾는메뉴설정
import MainOnboardPop from "@/components/paintpro/utility/mainOnBoardLayer.vue";

import * as store from "@/store";
import * as cmApi from "@/api/cmApi";
import * as cmUtil from "@/utils/cmUtil.js";

import MainSwiper01 from "@/components/common/swiper/main01Swiper.vue";
import MainSwiper02 from "@/components/common/swiper/main02Swiper.vue";
import MainSwiper03 from "@/components/common/swiper/main03Swiper.vue";
import MainSwiper04 from "@/components/common/swiper/main04Swiper.vue";

import MainChart01 from "@/components/common/chart/main01Chart.vue";
import MainChart02 from "@/components/common/chart/main02Chart.vue";

import { useRouter } from "vue-router";
import { api } from "@/plugins/api";
import Utils from "@/js/utils";
import "@/assets/scss/main.scss";

const url = inject("url_prefix");
const router = useRouter();
const keyword = ref("");
const { isMobile } = cmUtil.useDeviceType();

/***********************
 * 데이타 모음
 **********************/
const data = reactive({
  isLogin: false,
  isCombinlVisible: false,
  page: {
    userLoginInfo: {}, //로그인 유저 정보
    basketCount: {}, //장바구니 카운트
    userBasketList: [],
    breadcrumbItems: [], //우측 메뉴 경로
    empIndex: 0,
  },
  popup: {
    isMenuSettingPop: false,
    isMainOnboardPop: false,
  },

  /* 자주 쓰는 메뉴 */
  menu: {
    list: [],
    search: {},
    default: [
      {
        prgrmId: "1",
        menuSeNm: "주문내역",
        useYn: "N",
        menuUrl: "/paintpro/orderList",
      },
      {
        prgrmId: "2",
        menuSeNm: "출고현황",
        useYn: "N",
        menuUrl: "/paintpro/orderList/shipmentList",
      },
      {
        prgrmId: "3",
        menuSeNm: "매입현황",
        useYn: "N",
        menuUrl: "/paintpro/orderList/purchaseList",
      },
      {
        prgrmId: "4",
        menuSeNm: "배합문의",
        useYn: "N",
        menuUrl: "/paintpro/colorCombinList",
      },
      {
        prgrmId: "5",
        menuSeNm: "1:1 문의",
        useYn: "N",
        menuUrl: "/paintpro/custCenterList/reqList",
      },
    ],
  },

  /* 주문현황 / 매입현황 / 출고현황 */
  order: {
    loading: false,
    search: {
      searchDateSt: "",
      searchDateEd: "",
      vkbur: "",
      agencySn: "",
    },
    orderCnt01: {},
    orderCnt02: {},
    orderCnt03: {},
    orderCnt04: {},
    orderCnt05: {},
  },

  /* 월 매입현황(바 그래프) */
  chart01: {
    type: "bar",
    chartData: {
      labels: [],
      datasets: [
        {
          data: [],
          backgroundColor: (context) => {
            return context.dataIndex === context.dataset.data.length - 1
              ? "#007D6C"
              : "#C8EFE5";
          },
          hoverBackgroundColor: (context) => {
            return context.dataIndex === context.dataset.data.length - 1
              ? "#007D6C"
              : "#C8EFE5";
          },
          borderRadius: 30,
          barThickness: 20,
        },
      ],
    },
  },
  /* 월 매출현황(라인 그래프) */
  chart02: {
    type: "line",
    chartData: {
      labels: [],
      datasets: [
        {
          data: [],
          titleColor: "#000000",
          borderColor: "rgba(0, 125, 108, 0.5)",
          backgroundColor: function (context) {
            const chart = context.chart;
            const { ctx, chartArea } = chart;

            if (!chartArea) {
              return null;
            }

            const gradient = ctx.createLinearGradient(
              0,
              chartArea.top,
              0,
              chartArea.bottom
            );
            gradient.addColorStop(0, "rgba(0, 125, 108, 0.3)");
            gradient.addColorStop(1, "rgba(255, 255, 255, 0)");

            return gradient;
          },
          fill: true,
          tension: 0,
          borderWidth: 3,
          pointRadius: 3,
          pointBackgroundColor: "#007D6C",
          pointBorderWidth: 0,
        },
      ],
    },
  },

  /* 제품 */
  isTab1: true,
  isTab2: true,
  isTab01Nm: "",
  isTab02Nm: "",
  orderCnt: 1,
  quickSwiper: true,
  swiper: {
    agencySn: "",
    kunn2: "",
    vkorg: "",
    vtweg: "",
    vwerk: "",
    fashionRcmdtnSeCd: "F",
    orderType: "M",
  },
  /* 공지사항 */
  notice: {
    loading: false,
    list: [],
  },
});

/**********************
 * 마운트
 *********************/
onMounted(() => {
  paegInit(); // 페이지 초기화 호출
  settingDate();
});

/*********************
 * 페이지 초기함
 *********************/
async function paegInit() {
  await pageInitData();

  //공통팝업 호출
  cmApi.checkCookiePop();
  cmApi.checkCommonPop();

  selectMenu();
  selectOrder01();
  selectNotice();
  selectMain01();
  selectMain02();
}

/**********************
 * 페이지 초기 데이타 조회
 *********************/
async function pageInitData() {
  // ◼◼◼ 초기데이타 조회
  const mparm = [];

  const res = await cmApi.getPageInitData(mparm);
  const { resultCode } = res;
  if (resultCode !== 200) {
    // alert(`errror : resultCode:${resultCode}, message:${message} `);
    return false;
  }

  const { userLoginInfo } = res.data;
  data.page.userLoginInfo = userLoginInfo;

  // 해당 대리점에서 구매이력이 있는 지 조회
  await selectOrderCnt({
    agencySn: userLoginInfo.agencySn,
    matkl:
      userLoginInfo.empList[store.useEventBusStore().salesPersonIndex].matkl,
  });

  let params = {};
  params.agencySn = userLoginInfo.agencySn;
  params.fashionRcmdtnSeCd = "F";
  params.orderType = data.orderCnt > 0 ? "M" : "AL";
  params.kunn2 =
    userLoginInfo.empList[store.useEventBusStore().salesPersonIndex].kunn2;
  params.vkorg =
    userLoginInfo.empList[store.useEventBusStore().salesPersonIndex].vkorg;
  params.vtweg =
    userLoginInfo.empList[store.useEventBusStore().salesPersonIndex].vtweg;
  params.spart =
    userLoginInfo.empList[store.useEventBusStore().salesPersonIndex].spart;
  params.matkl =
    userLoginInfo.empList[store.useEventBusStore().salesPersonIndex].matkl;

  data.swiper = params;

  if (
    cmUtil.getToday().indexOf("202504") > -1 ||
    cmUtil.getToday().indexOf("202505") > -1
  ) {
    if (
      cmUtil.getLocalStorage("gv.mainOnBoardLayer.hiddenDate") !==
      cmUtil.getToday()
    ) {
      if (res.data?.userLoginInfo?.mainManualIdntyYn === "N") {
        data.popup.isMainOnboardPop = true;
      }
    }
  } else {
    if (res.data?.userLoginInfo?.mainManualIdntyYn === "N") {
      cmApi.updateUserPersonInfo({
        type: "mainManualIdntyYn",
      });
      data.popup.isMainOnboardPop = true;
    }
  }

  data.page.empIndex = store.useEventBusStore()?.salesPersonIndex;
}

watch(
  () => store.useEventBusStore()?.salesPersonIndex,
  (newValue) => {
    if (data.page.userLoginInfo?.empList?.length > 0) {
      data.page.empIndex = newValue;
      data.swiper.kunn2 = data.page.userLoginInfo.empList[newValue].kunn2;
      data.swiper.matkl = data.page.userLoginInfo.empList[newValue].matkl;
      selectNotice();
      data.isTab1 = true;
      selectOrderCnt({
        agencySn: data.page.userLoginInfo.agencySn,
        matkl: data.page.userLoginInfo.empList[newValue].matkl,
      });
    }
  }
);

/**********************
 * 팝업 닫기
 *********************/
const closePopup = () => {
  data.popup.isMenuSettingPop = false;
};

provide("closePopup", closePopup);

/**********************
 * 탭 활성화 처리
 *********************/
const tabActive = (event) => {
  const tabInfo = event.target.id.split("-");

  //isTab1(자주 구매한 제품 / 최근 구매한 제품)
  if (tabInfo[1] == "1") {
    if (tabInfo[2] == "1") {
      if (data.orderCnt > 0) {
        data.isTab1 = true;
        data.swiper.orderType = "M";
      } else {
        data.isTab1 = true;
        data.swiper.orderType = "AL";
      }
    } else {
      if (data.orderCnt > 0) {
        data.isTab1 = false;
        data.swiper.orderType = "R";
      } else {
        data.isTab1 = false;
        data.swiper.orderType = "AO";
      }
    }
  }
  //isTab2(인기 제품/추천 제품)
  else if (tabInfo[1] == "2") {
    if (tabInfo[2] == "1") {
      data.isTab2 = true;
      data.swiper.fashionRcmdtnSeCd = "F";
    } else {
      data.isTab2 = false;
      data.swiper.fashionRcmdtnSeCd = "R";
    }
  }
};

// 주문내역이 있지만 구매상품이 아닌 경우 많이 찾는 제품 탭으로 변경
async function changeTabType(type) {
  switch (type) {
    case "M":
    case "R":
      selectOrderCnt({
        agencySn: data.page.userLoginInfo.agencySn,
        matkl: data.page.userLoginInfo.empList[data.page.empIndex].matkl,
      });
      break;
    case "AL":
    case "AO":
      data.orderCnt = 0;
      break;
  }
  data.swiper.orderType = type;
}

/**********************
 * 조회 모음
 *********************/
// 자주 쓰는 메뉴
async function selectMenu() {
  data.popup.isMenuSettingPop == false;

  const res = await cmApi.selectUserBookmarkMenuList();

  let resList = res.data;
  if (resList.length > 0) {
    //사용자가 등록한 즐겨찾기 메뉴를 관리자가 등록한 메뉴에서 제외처리
    let defaultList = data.menu.default;
    let filterArry = [];
    for (let i in resList) {
      defaultList = await filtering(defaultList, resList[i].prgrmId);
      filterArry = defaultList;
    }

    //자주 쓰는 메뉴 5개 맞추기
    if (resList.length < 5) {
      for (let i in filterArry) {
        resList.push(filterArry[i]);
        if (resList.length > 4) {
          break;
        }
      }
    }

    //5개 세팅한 메뉴 보여주기기
    data.menu.list = resList;
  } else {
    data.menu.list = data.menu.default;
  }
}

//관리자 등록 메뉴 필터링 처리
async function filtering(arry, item) {
  return arry.filter(function (ele) {
    return ele.prgrmId != item;
  });
}

// 주문현황 건수 모음
async function selectOrder01() {
  data.order.loading = true;

  const res = await api.get(`${url}/order/selectOrderStatusCount`, {
    params: {
      searchDateSt: data.order.search.searchDateSt,
      searchDateEd: data.order.search.searchDateEd,
    },
  });

  data.order.orderCnt01 = res.data[0];
  data.order.orderCnt02 = res.data[1];
  data.order.orderCnt03 = res.data[2];
  data.order.orderCnt04 = res.data[3];
  data.order.orderCnt05 = res.data[4];
  data.order.loading = false;
}

// 월 매입현황
async function selectMain01() {
  data.order.loading = true;

  const res = await api.get(`${url}/order/selectPurchaseGraph`);
  let resList = res.data.slice(1);

  let arry = [];
  let sysData = [];
  resList.forEach((ele, idx) => {
    let year = ele.fkdatYear;
    let month = ele.fkdatMonth;
    let value = ele.totalSum;
    arry.push({ year, month, value });

    if (idx == resList.length - 2) {
      //전월 매입금액
      sysData.push(ele.totalSum);
    } else if (idx == resList.length - 1) {
      //현재 월과 매입금액
      sysData.push(ele.totalSum);
      sysData.push(ele.fkdatMonth);
    }
  });

  if (isMobile.value) {
    // MO: 6월부터 11월까지 (최근 6개월)
    arry.slice(-6).map((item) => [item.year, item.month, item.value]);
  } else {
    // PC: 전체 12개월
    arry.map((item) => [item.year, item.month, item.value]);
  }

  data.chart01 = {
    type: "bar",
    year: arry.map((el) => el["year"]),
    sysData: sysData,
    chartData: {
      labels: arry.map((el) => el["month"]),
      datasets: [
        {
          data: arry.map((el) => el["value"]),
          backgroundColor: (context) => {
            return context.dataIndex === context.dataset.data.length - 1
              ? "#007D6C"
              : "#C8EFE5";
          },
          hoverBackgroundColor: (context) => {
            return context.dataIndex === context.dataset.data.length - 1
              ? "#007D6C"
              : "#C8EFE5";
          },
          borderRadius: 30,
          barThickness: 20,
        },
      ],
    },
  };

  data.order.loading = false;
}

// 월 출고현황
async function selectMain02() {
  data.order.loading = true;

  const res = await api.get(`${url}/order/selectShipmentGraph`);
  let resList = res.data.slice(1);

  let arry = [];
  let sysData = [];
  resList.forEach((ele, idx) => {
    let year = ele.wadatIstYear;
    let month = ele.wadatIstMonth;
    let value = ele.totalCount;
    let sum = ele.totalSum;
    arry.push({ year, month, value, sum });

    if (idx == resList.length - 2) {
      //전월 출고 건
      sysData.push(ele.totalCount);
    } else if (idx == resList.length - 1) {
      //현재 월과 출고 건
      sysData.push(ele.totalCount);
      sysData.push(ele.wadatIstMonth);
    }
  });

  if (isMobile.value) {
    // MO: 6월부터 11월까지 (최근 6개월)
    arry.slice(-6).map((item) => [item.year, item.month, item.value, item.sum]);
  } else {
    // PC: 전체 12개월
    arry.map((item) => [item.year, item.month, item.value, item.sum]);
  }

  data.chart02 = {
    type: "line",
    year: arry.map((el) => el["year"]),
    sum: arry.map((el) => el["sum"]),
    sysData: sysData,
    chartData: {
      labels: arry.map((el) => el["month"]),
      datasets: [
        {
          data: arry.map((el) => el["value"]),
          titleColor: "#000000",
          borderColor: "rgba(0, 125, 108, 0.5)",
          backgroundColor: function (context) {
            const chart = context.chart;
            const { ctx, chartArea } = chart;

            if (!chartArea) {
              return null;
            }

            const gradient = ctx.createLinearGradient(
              0,
              chartArea.top,
              0,
              chartArea.bottom
            );
            gradient.addColorStop(0, "rgba(0, 125, 108, 0.3)");
            gradient.addColorStop(1, "rgba(255, 255, 255, 0)");

            return gradient;
          },
          fill: true,
          tension: 0,
          borderWidth: 3,
          pointRadius: 3,
          pointBackgroundColor: "#007D6C",
          pointBorderWidth: 0,
        },
      ],
    },
  };

  data.order.loading = false;
}

// 공지사항
async function selectNotice() {
  data.notice.loading = true;

  const res = await api.post(`${url}/main/mainNotice01`, {
    ntcMttrMrktCd: data.page.userLoginInfo.empList[data.page.empIndex].matkl,
    vtweg: data.page.userLoginInfo.empList[data.page.empIndex].vtweg,
    vwerk: data.page.userLoginInfo.empList[data.page.empIndex].vwerk,
  });
  data.notice.list = res.data;

  data.notice.loading = false;
}

// 선택한 영업소의 구분에 따른 주문 내역 조회
async function selectOrderCnt(params = {}) {
  data.swiper.orderType = "M";

  const res = await api.post(`${url}/main/mainOrderCnt`, {
    agencySn: params.agencySn,
    matkl: params.matkl,
  });

  data.orderCnt = res.data;
}

/**********************
 * 버튼 동작 모음
 *********************/
async function btnCmdFun(cmd = "") {
  // 자주찾는 메뉴 세팅 팝업
  if (cmd == "setting") {
    data.popup.isMenuSettingPop = !data.popup.isMenuSettingPop;
  }
}

/**********************
 * 제품 검색
 *********************/
const onSearchKeywordChange = async () => {
  if (Utils.isBlank(keyword.value)) {
    await cmUtil.alert("검색어를 입력하세요.");
    return;
  }

  router.push({
    name: `/paintpro/search`,
    query: {
      keyword: keyword.value,
    },
  });
};

/**********************
 * 화면 이동 모음
 *********************/
async function routerCmd(cmd = "", param = {}) {
  // 주문현황
  if (cmd == "order") {
    store.useOrderListStatusStore().setOrderListTabIdx(0);
    store.useOrderListStatusStore().setOrderListStatusCd(param.info);
    router.push({
      name: "/paintpro/orderList",
    });
  }
  // 공지사항
  else if (cmd == "noticeAll") {
    router.push({
      name: "/paintpro/custCenterList/noticeList",
    });
  }
  // 특정 공지사항 게시물 열기
  else if (cmd == "notice") {
    router.push({
      path: `/paintpro/custCenterList/noticeList/${param["ntcMttrSn"]}`,
    });
  }
  // 자주 찾는 메뉴
  else if (cmd == "routerMenu") {
    router.push({
      name: param.menuUrl,
    });
  }
}

/**********************
 * 주문 현황 날짜 세팅
 *********************/
async function settingDate() {
  const today = new Date();
  let statrDt = new Date(today);

  //주문현황 시작일
  statrDt.setDate(today.getDate() - 29);

  const options = {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  };

  statrDt = statrDt.toLocaleDateString("en-CA", options);
  let now = today.toLocaleDateString("en-CA", options);

  data.order.search.searchDateSt = statrDt;
  data.order.search.searchDateEd = now;
}

/**********************
 * script 태그와 이벤트 핸들러 제거
 *********************/
function sanitizeHTML(html) {
  return cmUtil.sanitizeHTML(html);
}
</script>
